import { render, staticRenderFns } from "./AffiliationCheckout.vue?vue&type=template&id=4ad50f58&scoped=true"
import script from "./AffiliationCheckout.vue?vue&type=script&lang=js"
export * from "./AffiliationCheckout.vue?vue&type=script&lang=js"
import style0 from "./AffiliationCheckout.vue?vue&type=style&index=0&id=4ad50f58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad50f58",
  null
  
)

export default component.exports